import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Breadcrumb } from '../models/breadcrumbs.model';

@Component({
  selector: 'auto-editor-ratenow-ui-breadcrumbs',
  templateUrl: './ui-breadcrumbs.component.html',
  styleUrl: './ui-breadcrumbs.component.scss',
  standalone: false
})
export class UiBreadcrumbsComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];
  params!: { [key: string]: any };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.params = this.activatedRoute.root.snapshot.params;
    this.updateData(this.activatedRoute.root, null);
  }

  ngOnInit() {
    this.router.events
      .pipe(
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        distinctUntilChanged()
      )
      .subscribe((route) => {
        this.params = route.snapshot.params;
        this.updateData(route, null);
        this.cdr.detectChanges();
      });
  }

  private updateData(route: ActivatedRoute, newBreadcrumb?: Breadcrumb[] | null): void {
    if (route.snapshot.data['breadcrumbs'] || newBreadcrumb) {
      const data = route.snapshot.data['breadcrumbs'] ? route.snapshot.data['breadcrumbs'] : newBreadcrumb;

      const breadcrumb = JSON.parse(JSON.stringify(data));

      breadcrumb.map((crumb: Breadcrumb) => {
        const urlChunks = crumb.url.split('/');
        for (const chunk of urlChunks) {
          if (chunk.includes(':')) {
            const paramID = chunk.replace(':', '');
            const routerParamID = this.params[paramID];
            crumb.url = crumb.url.replace(`:${paramID}`, routerParamID);
          }
        }

        const labelParams = crumb.label.match(/[^{{]+(?=\}})/g);
        if (labelParams) {
          for (const labelParam of labelParams) {
            const routerParamID = this.params[labelParam.trim()];
            if (routerParamID) {
              crumb.label = crumb.label.replace('{{' + labelParam + '}}', routerParamID);
            }
          }
        }
      });

      this.breadcrumbs = breadcrumb;
    } else {
      this.breadcrumbs = [];
    }
  }
}
